"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableQueryGovParamDeposit = exports.ObservableQueryGovParamVoting = exports.ObservableQueryGovParamTally = void 0;
const chain_query_1 = require("../../chain-query");
class ObservableQueryGovParamTally extends chain_query_1.ObservableChainQuery {
    constructor(kvStore, chainId, chainGetter) {
        super(kvStore, chainId, chainGetter, `/cosmos/gov/v1beta1/params/tallying`);
    }
}
exports.ObservableQueryGovParamTally = ObservableQueryGovParamTally;
class ObservableQueryGovParamVoting extends chain_query_1.ObservableChainQuery {
    constructor(kvStore, chainId, chainGetter) {
        super(kvStore, chainId, chainGetter, `/cosmos/gov/v1beta1/params/voting`);
    }
}
exports.ObservableQueryGovParamVoting = ObservableQueryGovParamVoting;
class ObservableQueryGovParamDeposit extends chain_query_1.ObservableChainQuery {
    constructor(kvStore, chainId, chainGetter) {
        super(kvStore, chainId, chainGetter, `/cosmos/gov/v1beta1/params/deposit`);
    }
}
exports.ObservableQueryGovParamDeposit = ObservableQueryGovParamDeposit;
//# sourceMappingURL=params.js.map